/* eslint-disable no-unused-vars */

'use strict';

const focusHelper = require('base/components/focus');
const productImageGallery = require('./productImageGallery');
const productAttributeSections = require('../components/productAttributeSections');
const siteAlert = require('../components/alert');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    let pid;

    if ($el && $el.length && $el.data('pid')) {
        return $el.data('pid');
    }

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $('.set-image-item').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    let quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        const quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        const quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $el.find('.quantity-select');
    }

    // edge case
    if (!quantitySelected.length) {
        quantitySelected = $('.quantity-select');
    }

    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    $productContainer.find('[data-attr="' + attr.id + '"]  .js-variation-attr-name-value').text(attr.displayValue || msgs.pleaseSelect);

    attr.values.forEach(function (attrValue) {
        const $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        const $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processNonSwatchValues(attr, $productContainer, msgs) {
    const $attr = '[data-attr="' + attr.id + '"]';
    const $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        const $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .text(attrValue.displayValue + (!attrValue.selectable ? ' - ' + msgs.outOfStock : ''));
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    const attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer, msgs);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    let availabilityValue = '';
    const availabilityMessages = response.product.availability.messages;

    if (!response.product.purchasable) {
        availabilityValue = '<li><div class="text-warning">' + response.resources.info_orderableinstores + '</div></li>';
    } else if (!response.product.readyToOrder && response.product.available) {
        availabilityValue = '<li><div class="text-warning">' + response.resources.info_selectforstock + '</div></li>';
    } else if (!response.product.available && response.product.stores.length > 0) {
        availabilityValue = '<li><div>' + response.resources.availableInStore + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    let html = '';

    attributes.forEach(function (attribute) {
        html += '<div class="js-head-attribute">'
            + '<dt>' + attribute.label + ':</dt>'
            + '\n'
            + '<dd>' + attribute.value + '</dd>'
        + '</div>';
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images, along with related information
 * @param {Object[]} previewImgs - Array of small product images, along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, previewImgs, $productContainer) {
    const $carousel = $productContainer.find('.carousel').first();
    $carousel.carousel('dispose');

    const carouselID = $carousel.attr('id');
    const $existingAiLabel = $carousel.find('.ai-image-label').first();
    const aiImageLabelText = $carousel.attr('data-ai-image-label') || ($existingAiLabel.length ? ($existingAiLabel.attr('title') || $existingAiLabel.text()) : '');
    const aiImageLabelStyle = $carousel.attr('data-ai-image-label-style') || ($existingAiLabel.length ? ($existingAiLabel.attr('style') || '') : '');

    const $carouselInner = $('<div class="carousel-inner" role="listbox"></div>');
    const $carouselPreview = $('<div class="row carousel-preview"></div>');

    const $carouselPrev = $('<a class="carousel-control-next" href="#' + carouselID + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $carousel.data('next') + '</span></a>');
    const $carouselNext = $('<a class="carousel-control-prev" href="#' + carouselID + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $carousel.data('prev') + '</span></a>');
    $carouselInner.append($carouselPrev);
    $carouselInner.append($carouselNext);

    $carousel.empty();
    $carousel.append($carouselInner);
    $carousel.append($carouselPreview);

    if (aiImageLabelText) $carousel.attr('data-ai-image-label', aiImageLabelText);
    if (aiImageLabelStyle) $carousel.attr('data-ai-image-label-style', aiImageLabelStyle);

    const createAiImageLabel = () => {
        const $label = $('<span class="ai-image-label"></span>').attr('title', aiImageLabelText).text(aiImageLabelText);

        if (aiImageLabelStyle) $label.attr('style', aiImageLabelStyle);

        return $label;
    };

    for (let i = 0; i < imgs.length; i += 1) {
        const $carouselItem = $('<div class="carousel-item"></div>');

        const $img = $('<img/>');
        $img.attr('src', imgs[i].url);
        $img.attr('class', 'img-resize d-block img-fluid');
        $img.attr('alt', imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10));
        $img.attr('title', imgs[i].title);
        $img.attr('itemprop', 'image');

        $carouselItem.append($img);

        if (i > 0 && aiImageLabelText) $carouselItem.append(createAiImageLabel());

        $carouselInner.append($carouselItem);

        const $preview = $('<div class="col-2 col-sm-2 carousel-preview-item"></div>');
        $preview.attr('data-target', '#' + carouselID);
        $preview.attr('data-slide-to', i);

        const $previewImg = $('<div class="carousel-preview-image"></div>');
        $previewImg.attr('style', 'background: url(' + previewImgs[i].url + ')');

        if (i > 0 && aiImageLabelText) $previewImg.append(createAiImageLabel());

        $preview.append($previewImg);
        $carouselPreview.append($preview);
    }

    $carousel.find('.carousel-item').first().addClass('active');
    $carousel.find('.carousel-preview > div').first().addClass('active');
    if (imgs.length === 1) {
        $carousel.find('.carousel-preview, a[class^="carousel-control-"]').detach();
    }

    $carousel.carousel();
    $carouselPreview.attr('aria-hidden', true);
}

/**
 * Formats a number as a currency string in the specified locale and currency.
 *
 * @param {number} amount - The amount of money to format.
 * @param {string} currencyCode - The ISO 4217 currency code (e.g., 'EUR').
 * @param {string} locale - The locale to use for formatting (e.g., 'de-DE' for Germany).
 * @returns {string} The formatted currency string.
 */
function formatMoney(amount, currencyCode, locale = 'de-DE') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode
    }).format(amount);
}

/**
 * Updates the price labels within a specified container by calculating and displaying the savings
 * between the regular price and the promotional price.
 *
 * This function searches for visible elements within the given container that represent the regular
 * price and the promotional price. If both are found, it calculates the savings and updates the
 * savings label with the formatted savings amount.
 *
 * @param {jQuery} $container - The jQuery object representing the container element that holds
 *                              the price labels and savings information.
 */
function updateLabels($container) {
    const $regularPrice = $container.find('.js-label-price:visible');
    const $promoPrice = $container.find('.promo-price-item__value:visible');

    if ($regularPrice.length && $promoPrice.length) {
        const $savings = $container.find('.js-promo-savings:visible b');

        const regularPriceValue = parseFloat($regularPrice.text().replace('€', '').replace(',', '.').trim());
        const promoPriceValue = parseFloat($promoPrice.text().replace('€', '').replace(',', '.').trim());
        const savingsValue = regularPriceValue - promoPriceValue;
        const totalSavings = formatMoney(savingsValue, 'EUR');

        $savings.empty().append(totalSavings);
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    const isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    let isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    const primaryImageUrls = response.product.images.large;
    const previewImageUrls = response.product.images.small;

    if ($productContainer.find('.b-pdp-product-images').length && response.product.imagesHtml) {
        productImageGallery.replaceGallery(response.product.imagesHtml, $productContainer);
    } else {
        createCarousel(primaryImageUrls, previewImageUrls, $productContainer);
    }

    // Update product name
    // check logic here
    const productNameHtml = response.product.productName;

    $productContainer.find('.product-name').html(productNameHtml);

    // Update product id
    $productContainer.find('.js-product-id').html(response.product.id);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        const $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);

        $productContainer.find('.js-brochure-offer-badge').html(response.product.brochureOfferHtml || '');
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        const $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    const $attributesContainer = $productContainer.find('.js-head-attributes');
    $attributesContainer.find('.js-product-id').text(response.product.id);
    $attributesContainer.find('.js-head-attribute').remove();
    $attributesContainer.append(getAttributesHtml(response.product.headAttributes));

    updateLabels($productContainer.find('.prices, .attributes'));

    if (response.product.productAttributeSectionsHtml) {
        const $productAttributeSections = $productContainer.find('.js-product-attribute-sections');

        if ($productAttributeSections.length) {
            $productAttributeSections.replaceWith(response.product.productAttributeSectionsHtml);
        } else {
            $productContainer.find('.product-attribute-sections-column').first().append(response.product.productAttributeSectionsHtml);
        }

        productAttributeSections.initProductAttributeSections($productContainer);
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Resolves Product-Variation URL for the currently selected quantity.
 * @param {jQuery} $quantitySelector - quantity input element
 * @return {string|null} variation URL for the selected quantity
 */
function getQuantityVariationUrl($quantitySelector) {
    const shippingType = $quantitySelector.data('shipping-type');
    const packageQuantities = $quantitySelector.data('package-quantities');
    const quantities = shippingType === 'delivery' && packageQuantities ? packageQuantities : $quantitySelector.data('quantities');

    if (!quantities || !quantities.length) return null;

    let minQty = parseInt($quantitySelector.attr('min'), 10);
    let maxQty = parseInt($quantitySelector.attr('max'), 10);
    let selectedQty = parseInt($quantitySelector.val(), 10);

    // data normalization
    if (Number.isNaN(minQty)) minQty = parseInt(quantities[0].value, 10);
    if (Number.isNaN(maxQty)) maxQty = parseInt(quantities[quantities.length - 1].value, 10);
    if (selectedQty > maxQty) selectedQty = maxQty;
    if (selectedQty < minQty) selectedQty = minQty;

    const availableQuantities = quantities.filter(function (quantity) {
        const value = parseInt(quantity.value, 10);

        return value >= minQty && value <= maxQty;
    });

    if (!availableQuantities.length) return null;

    let quantityEntry = availableQuantities.find(function (quantity) {
        return parseInt(quantity.value, 10) === selectedQty;
    });

    if (!quantityEntry) {
        quantityEntry = availableQuantities.find(function (quantity) {
            return parseInt(quantity.value, 10) >= selectedQty;
        }) || availableQuantities[availableQuantities.length - 1];
    }

    return quantityEntry ? quantityEntry.url : null;
}

/**
 * Toggles set quantity UI and updates the visible set count label.
 * @param {jQuery} $quantitySelector - quantity input element
 * @param {string} [shippingType] - selected shipping type
 */
function updateSetQuantityUI($quantitySelector, shippingType) {
    const $wrapper = $quantitySelector.closest('.quantity-wrapper');
    const $group = $quantitySelector.closest('.quantity-input-group');

    if (!$wrapper.length) return;

    shippingType = shippingType || $quantitySelector.data('shipping-type');

    const isSetMode = shippingType === 'delivery' && $quantitySelector.data('package-quantities');
    const packageUnitCount = parseInt($quantitySelector.data('package-unit-count'), 10) || 1;
    const hintTemplate = $quantitySelector.data('hint-template');

    if ($group.length) {
        const value = parseInt($quantitySelector.val(), 10) || 1;
        const min = parseInt($quantitySelector.attr('min'), 10) || 1;
        const max = parseInt($quantitySelector.attr('max'), 10);

        $group.find('.quantity-btn--minus').prop('disabled', value <= min);
        $group.find('.quantity-btn--plus').prop('disabled', !Number.isNaN(max) && value >= max);
    }

    if (isSetMode) {
        if (hintTemplate) $wrapper.find('.js-quantity-package-hint').text(hintTemplate.replace('__PIECES__', packageUnitCount));

        $wrapper.addClass('quantity-wrapper--packages');
    } else {
        $wrapper.removeClass('quantity-wrapper--packages');
        return;
    }

    const setCount = Math.round((parseInt($quantitySelector.val(), 10) || 1) / packageUnitCount);

    $wrapper.find('.js-quantity-sets-display').text(setCount + ' ' + $quantitySelector.data('label-set'));
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {Object} product - Product model
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {number} [selectedValue] - Value to be selected
 * @param {string} shippingType - Shipping type
 */
function updateQuantities(product, $productContainer, selectedValue, shippingType) {
    if ($productContainer.parent('.bonus-product-item').length > 0) return;

    const $quantitySelector = getQuantitySelector($productContainer);
    let quantities;

    if (shippingType) {
        $quantitySelector.data('shipping-type', shippingType);
    } else {
        shippingType = $quantitySelector.data('shipping-type');
    }

    if (product) {
        $quantitySelector.data('package-quantities', product.packageQuantities);
        $quantitySelector.data('quantities', product.quantities);

        if (product.packageUnitCount) $quantitySelector.data('package-unit-count', product.packageUnitCount);
    }

    const packageQuantities = $quantitySelector.data('package-quantities');

    quantities = shippingType === 'delivery' && packageQuantities ? packageQuantities : $quantitySelector.data('quantities');

    if (!quantities) return;

    let maxQty = parseInt(quantities.at(-1).value, 10);
    const minQty = parseInt(quantities[0].value, 10);
    const availableCount = $quantitySelector.data('available-count');
    const packageUnitCount = parseInt($quantitySelector.data('package-unit-count'), 10) || 1;
    let selectedQty = parseInt(selectedValue || $quantitySelector.val(), 10) || minQty;

    // data normalization
    for (let index = 0; index < quantities.length; index++) {
        const quantity = quantities[index];

        if (quantity.value > availableCount) {
            maxQty = quantities[index - 1].value;
            break;
        }
    }
    if (selectedQty > maxQty) selectedQty = maxQty;
    if (selectedQty < minQty) selectedQty = minQty;

    $quantitySelector.attr({ max: maxQty, min: minQty, step: shippingType === 'delivery' && packageQuantities ? packageUnitCount : 1 });
    $quantitySelector.val(selectedQty);
    updateSetQuantityUI($quantitySelector, shippingType);
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer }
                );
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.choice-of-bonus-product');
    const footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    const htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            const parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Shows the add-to-cart toast and, on success, a cart link.
 * @param {Object} response - ajax response from clicking the add to cart button
 * @param {Object} [options] - Extra toast options
 */
function showAddToBasketAlert(response, options) {
    const config = options || {};
    const $cartLink = $('.minicart-link').first();

    siteAlert.show({
        type: response.error ? 'error' : 'success',
        message: response.message,
        link: response.error ? null : {
            href: $cartLink.attr('href'),
            text: $cartLink.attr('data-goto-cart')
        },
        timeout: config.timeout != null ? config.timeout : 7000,
        onHide: config.onHide
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);

    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
        return;
    }

    showAddToBasketAlert(response);
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    const childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    const options = $productContainer
        .find('.product-option')
        .map(function () {
            const $elOption = $(this).find('.options-select');
            const urlValue = $elOption.val();
            const selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * @description check if Basket Freeze cookie already set
 * @returns {string} Basket Freeze cookie value
 */
function isBasketFreezeeCookieAdded() {
    const value = '; ' + document.cookie;
    const parts = value.split('; isBasketFreeze=');
    let basketFreezeCookieValue = '';

    if (parts.length === 2) {
        basketFreezeCookieValue = parts.pop().split(';').shift();
    }

    return basketFreezeCookieValue;
}

/**
 * @description add product to cart from VVIINN block
 * @param {string} pid - product ID
 */
function addVviinnProductToCart(pid) {
    $('body').trigger('product:beforeAddToCart', this);
    const vviinnMode = $('.js-vviinn-block').attr('data-vviinn-mode');
    let mainProductID = '';
    const addToCartUrl = getAddToCartUrl();
    let form = {};

    if ($($('.js-product-id').html()).length === 0) {
        mainProductID = $('.js-product-id').html();
    } else {
        mainProductID = $($('.js-product-id').html()).text();
    }

    if (vviinnMode === 'set') {
        const isUniqueVVIINNProductSet = mainProductID === pid;
        const pidsObj = [
            {
                pid: mainProductID,
                qty: 1,
                isMainProduct: true,
                isVVIINNProductSet: true
            },
            {
                pid: pid,
                qty: 1,
                isVVIINNProductSet: true
            }
        ];

        form = {
            pid: mainProductID,
            pidsObj: JSON.stringify(pidsObj),
            quantity: 1,
            isVviinnProduct: true,
            isUniqueVVIINNProductSet: isUniqueVVIINNProductSet
        };
    } else {
        form = {
            pid: pid,
            quantity: 1,
            isVviinnProduct: true
        };
    }

    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();

                if (!isBasketFreezeeCookieAdded()) {
                    const basketFreezeCookieExpiration = $('.add-to-cart').data('basket-freeze-exp-time');
                    const basketFreezeTime = Number(basketFreezeCookieExpiration) * 3600;

                    document.cookie = 'isBasketFreeze=true; path=/; max-age=' + basketFreezeTime;
                }

                miniCartReportingUrl(data.reportingURL);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Adds product to cart handler
 * @returns {void}
 */
function addProductToCart() {
    const $this = $(this);

    let addToCartUrl;
    let pid;
    let pidsObj;
    let setPids;
    const isTileAddToCart = $this.hasClass('js-product-tile-add-to-cart') && $this.closest('.recommendations-carousel').length;

    $('body').trigger('product:beforeAddToCart', this);

    if ($('.set-items').length && $this.hasClass('add-to-cart-global')) {
        setPids = [];

        $('.product-detail').each(function () {
            if (!$this.hasClass('product-set-detail')) {
                setPids.push({
                    pid: $this.find('.product-id').text(),
                    qty: $this.find('.quantity-select').val() || $('.set-main-info').find('.quantity-select').val(),
                    options: getOptions($this)
                });
            }
        });

        pidsObj = JSON.stringify(setPids);
    }

    pid = getPidValue($this);

    const $productContainer = $this.closest('.product-detail').length
        ? $this.closest('.product-detail')
        : $this.closest('.quick-view-dialog').find('.product-detail');

    addToCartUrl = getAddToCartUrl();

    const $shippingSelector = $productContainer.find('.js-shipping-selector:checked').length
        ? $productContainer.find('.js-shipping-selector:checked')
        : $productContainer.find('.js-shipping-selector');

    let form;

    if (isTileAddToCart) {
        form = {
            pid: pid,
            quantity: 1
        };
    } else {
        form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: getQuantitySelected($productContainer),
            shippingType: $shippingSelector.val() || $productContainer.attr('data-shipping-type') || null
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }
    }

    $this.trigger('updateAddToCartFormData', form);
    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();

                if (!isBasketFreezeeCookieAdded()) {
                    const basketFreezeCookieExpiration = $('.add-to-cart').data('basket-freeze-exp-time');
                    const basketFreezeTime = Number(basketFreezeCookieExpiration) * 3600;

                    document.cookie = 'isBasketFreeze=true; path=/; max-age=' + basketFreezeTime;
                }

                miniCartReportingUrl(data.reportingURL);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

// code debt due to some event listeners initializing multiple times
window.productBaseMethodsInited = window.productBaseMethodsInited || {};

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        addProductToCart: addProductToCart
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            const focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            let $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();
            const $productContainer = $(this).closest('.product-detail');

            $('body').trigger(
                'product:beforeAttributeSelect',
                { container: $productContainer }
            );

            const variationsInfo = $('#custom-variation').data('variations-info');
            const selectedColor = $('.js-color-swatch.selected').data('color-value') || '';

            const selectedVariation = variationsInfo.find(function (variantData) {
                return variantData.color === selectedColor && variantData.size === e.currentTarget.value;
            });

            window.location.href = selectedVariation.productUrl;
        });
    },

    changeColor: function () {
        $(document).on('click', '.js-color-btn', function (e) {
            e.preventDefault();

            const prevColorSwatch = $('.js-color-swatch.selected');
            const currentColorSwatch = $(this).find('.js-color-swatch');

            prevColorSwatch.removeClass('selected');
            currentColorSwatch.addClass('selected');

            const variationsInfo = $('#custom-variation').data('variations-info');
            const selectedColor = $(this).data('color-value');

            const $productContainer = $(this).closest('.product-detail');

            $('body').trigger(
                'product:beforeAttributeSelect',
                { container: $productContainer }
            );

            const selectedVariation = variationsInfo.find(function (variantData) {
                if (variantData.size) {
                    return variantData.color === selectedColor && variantData.sizeSortPosition === 1;
                }

                return variantData.color === selectedColor;
            });

            window.location.href = selectedVariation.productUrl;
        });
    },

    availability: function () {
        if (window.productBaseMethodsInited.availability) {
            return;
        }

        $(document).on('click', '.quantity-btn--minus, .quantity-btn--plus', function () {
            const $input = $(this).siblings('.quantity-select');
            const step = parseInt($input.attr('step'), 10) || 1;
            const max = parseInt($input.attr('max'), 10);
            const min = parseInt($input.attr('min'), 10) || 1;
            let qty = (parseInt($input.val(), 10) || min) + ($(this).hasClass('quantity-btn--plus') ? step : -step);

            if (qty > max) qty = max;
            if (qty < min) qty = min;

            $input.val(qty).trigger('change');
            updateSetQuantityUI($input);
        });

        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                const $quantitySelector = $(e.currentTarget);
                const minQty = parseInt($quantitySelector.attr('min'), 10) || 1;
                const maxQty = parseInt($quantitySelector.attr('max'), 10);
                const selectedQty = parseInt($quantitySelector.val(), 10);

                if (!Number.isNaN(maxQty) && selectedQty > maxQty) {
                    $quantitySelector.val(maxQty);
                } else if (selectedQty < minQty) {
                    $quantitySelector.val(minQty);
                }

                updateSetQuantityUI($quantitySelector);
                attributeSelect(getQuantityVariationUrl($quantitySelector), $productContainer);
            }
        });

        $('.js-product-quantity-selector').each(function () {
            const $quantitySelector = $(this);

            updateSetQuantityUI($quantitySelector);
        });

        window.productBaseMethodsInited.availability = true;
    },

    addToCart: function () {
        if (window.productBaseMethodsInited.addToCart) {
            return;
        }

        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            addProductToCart.call(this);
        });

        window.productBaseMethodsInited.addToCart = true;
    },

    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            const $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            const pid = $(this).data('pid');
            const maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            const submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            let totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            const optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            const valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                const selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            const $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            let count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available || !response.product.deliveryAvailable)
            );
            const pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            const url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    const parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            const $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            let queryString = '?pids=';
            const url = $('.choose-bonus-product-dialog').data('addtocarturl');
            const pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                const qtyOption = parseInt($(this).data('qty'), 10);
                let option = null;

                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        showAddToBasketAlert({
                            error: true,
                            message: data.errorMessage
                        }, { timeout: 3000 });
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        $('.minicart-quantity').html(data.totalQty);
                        showAddToBasketAlert({
                            error: false,
                            message: data.msgSuccess
                        }, {
                            timeout: 1500,
                            onHide: function () {
                                if ($('.cart-page').length) {
                                    // eslint-disable-next-line no-restricted-globals
                                    location.reload();
                                }
                            }
                        });
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    shippingTypeChange: function () {
        if (window.productBaseMethodsInited.shippingTypeChange) {
            return;
        }

        $(document).on('change', '.js-shipping-selector', function () {
            const $productContainer = $(this).closest('.product-detail, .product-wrapper');
            const shippingType = $(this).val();

            $productContainer.attr('data-shipping-type', shippingType);

            $('body').trigger('product:shippingTypeChange', {
                shippingType: shippingType,
                $productContainer: $productContainer
            });
        });

        window.productBaseMethodsInited.shippingTypeChange = true;
    },
    shippingTypeChangeOnProductPage: function () {
        if (window.productBaseMethodsInited.shippingTypeChangeOnProductPage) {
            return;
        }

        $('body').on('product:shippingTypeChange', function (ev, data) {
            data.$productContainer.data('isDeliverySelected', data.shippingType === 'delivery');

            const isDeliverySelected = data.$productContainer.data('isDeliverySelected');
            const $quantitySelector = getQuantitySelector(data.$productContainer);
            const useSelectedValue = false;
            const selectedValue = isDeliverySelected ? $quantitySelector.data('package-unit-count') : '1';

            updateQuantities(null, data.$productContainer, selectedValue, data.shippingType);

            if (!useSelectedValue) {
                $quantitySelector.eq(0).change();
            }

            data.$productContainer.attr('data-is-delivery-selected', isDeliverySelected);
            data.$productContainer.find('.js-package-unit-price').toggle(isDeliverySelected);
            data.$productContainer.find('.js-package-unit-price').siblings('.salePriceSpan').toggle(!isDeliverySelected);
            data.$productContainer.find('.js-package-unit-badge').toggle(isDeliverySelected);
            data.$productContainer.find('.js-package-unit-count-msg').toggle(isDeliverySelected);
        });

        window.productBaseMethodsInited.shippingTypeChangeOnProductPage = true;
    },
    handleProductStores: function () {
        if (window.productBaseMethodsInited.handleProductStores) {
            return;
        }

        $('body').on('product:afterAttributeSelect', function (ev, params) {
            params.container.find('.js-product-stores').replaceWith(params.data.product.storesHtml);
        });

        window.productBaseMethodsInited.handleProductStores = true;
    },
    updateShippingDetailsOnVariationChange: function () {
        if (window.productBaseMethodsInited.updateShippingDetailsOnVariationChange) {
            return;
        }

        $('body').on('product:afterAttributeSelect', function (ev, params) {
            const selectedShipping = params.container.attr('data-shipping-type');

            params.container.find('.js-product-delivery-methods-wrap').replaceWith(params.data.product.delivery.shippingSelectorHtml);
            params.container.find('.js-package-unit-count-msg-wrap').replaceWith(params.data.product.delivery.packageUnitCountMsgHtml);

            if (selectedShipping) {
                params.container.find('.js-shipping-selector[value="' + selectedShipping + '"]').prop('checked', true);
                params.container.attr('data-shipping-type', selectedShipping);
            }

            const isDeliverySelected = params.container.attr('data-is-delivery-selected') !== 'false';
            params.container.find('.js-package-unit-price').toggle(isDeliverySelected);
            params.container.find('.js-package-unit-price').siblings('.salePriceSpan').toggle(!isDeliverySelected);
            params.container.find('.js-package-unit-badge').toggle(isDeliverySelected);
            params.container.find('.js-package-unit-count-msg').toggle(isDeliverySelected);
        });

        window.productBaseMethodsInited.updateShippingDetailsOnVariationChange = true;
    },
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    addVviinnProductToCart: addVviinnProductToCart
};
